<main class="h-dvh w-full flex justify-center items-center relative bg-gray-50 dark:bg-slate-900">
  <app-loader/>
</main>
